export default {
  methods: {
    parseNoBreak(text) {
      const nobreakOpen = /<no-break>/g
      const nobreakClose = /<\/no-break>/g

      if (typeof text === "string") {
        text = text.replace(nobreakOpen, '<span style="white-space:nowrap;">')
        text = text.replace(nobreakClose, '</span>')
      }

      return text;
    }
  }
}
